module.exports = __webpack_public_path__ + "static/media/suit_left_img.ec4ccf82.svg";